export const LOADING_PLAN_CARRERA = "LOADING_PLAN_CARRERA";
export const SAVE_LOADING_PLAN_CARRERA = "SAVE_LOADING_PLAN_CARRERA";
export const GET_PLAN_CARRERA= "GET_PLAN_CARRERA";
export const FORM_FAIL = "FORM_FAIL";
export const PLAN_CARRERA_FAIL = "PLAN_CARRERA_FAIL";
export const GET_INFO_ENCABEZADO = "GET_INFO_ENCABEZADO";
export const LOADING_INFO_ENCABEZADO = "LOADING_INFO_ENCABEZADO";